angular.module('workflow')
    .controller('WorkflowShowFullController', function ($window, $state, $scope, $stateParams, $rootScope, Workflow, WorkflowService, Principal) {
        this.WorkflowService = WorkflowService
        this.Principal = Principal

        this.$onInit = () => {
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])
            this.load($stateParams.id)
        }

        this.hasThreadRows = () => {
            if (!(this.responseThread instanceof Array) || this.responseThread.length === 0) {
                return false
            }
            return !(this.responseThread.length === 1 && !this.responseThread[0].responseTo)
        }

        this.load = id => {
            Workflow.get({id: id}).$promise.then(item => {
                this.item = item;
                this.isLate = WorkflowService.isLate(item)
                this.daysLeft = WorkflowService.daysLeft(item)

                Principal.currentUser().then(user => {
                    this.isWorker = this.item.worker && this.item.worker.id === user.id
                })
            })
            Workflow.touches({id: id}).$promise.then(items => this.touches = items)
            Workflow.thread({id: id}).$promise.then(items => this.responseThread = items)
        }

        this.cancel = () => $window.history.back()
        this.canCancel = () => $window.history.length > 1

        $scope.$on('workflow.updated', () => {
            $rootScope.$broadcast('document.comments.reload', this.item.id)
            this.$onInit();
        })
        $scope.$on('workflow.deleted', () => $state.go('workflowList'))
        $scope.$on("file.saved", () => this.$onInit())
    })
